import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AdminLogListLayer from "../../components/Logs/AdminLogsLayer";


const AdminLogList = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Admin Logs" />

        {/* UsersListLayer */}
        <AdminLogListLayer />

      </MasterLayout>

    </>
  );
};

export default AdminLogList; 
